module.exports = __webpack_public_path__ + "img/Piece-18-2.5ea464f7.png";